/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import Text from 'relements/build/esm/ui/text';
import Box from 'relements/build/esm/ui/box';
import Dialog from 'relements/build/esm/overlays/dialog';

import ToolCard from '@src/components/ToolCard';
import { Container, Grid, Column } from './styledComponent';

const ToolList = ({
  toolList,
  isActiveToolExist,
  activeToolName,
  ectCredentials,
  navToBM,
  navToAthena,
  navToSetupFqdn,
  deactivateConfiguration,
  activateContactSalesTeamDialog,
}) => {
  const [isDeactivateDialogActive, setIsDeactivateDialogActive] = useState(
    false
  );
  const [isAthenaDialogActive, setIsAthenaDialogActive] = useState(false);
  const [fqdn, setFQDN] = useState('');
  const [toolName, setToolName] = useState('');

  const openAthenaTab = () => {
    setIsAthenaDialogActive(false);
    navToAthena();
  };

  const onClick = (tool) => {
    const { fqdn, name } = tool;
    if (fqdn === 'athena') {
      setIsAthenaDialogActive(true);
      return;
    }
    if (!ectCredentials[fqdn]) {
      activateContactSalesTeamDialog(name);
    } else if (isActiveToolExist) {
      setFQDN(fqdn);
      setToolName(name);
      setIsDeactivateDialogActive(true);
    } else navToSetupFqdn(fqdn);
  };

  const deleteActiveTool = useCallback(() => {
    deactivateConfiguration(
      () => {},
      () => {
        navToSetupFqdn(fqdn);
      }
    );
  }, [fqdn, deactivateConfiguration, navToSetupFqdn]);

  return (
    <Container isActiveToolExist={isActiveToolExist}>
      <Dialog
        active={isDeactivateDialogActive}
        onClose={() => setIsDeactivateDialogActive(false)}
        title={`Do you want to configure ${toolName}?`}
        subtitle={`You will have to deactivate ${activeToolName} to activate ${toolName} as your new Agent Escalation tool.`}
        primaryActionText={`Delete ${activeToolName}`}
        secondaryActionText="Cancel"
        primaryAction={deleteActiveTool}
      />
      <Text variant="h3.semi-bold" color="black.haptik">
        All Tools
      </Text>
      {!isActiveToolExist && (
        <Box padding="zero" marginTop="16px">
          <Text variant="body.md">
            Haptik’s smart agent chat is enabled by default. You can select the
            tool of your choice and configure it.
          </Text>
        </Box>
      )}
      <Grid gridGap={10}>
        {toolList.map((tool) => (
          <Column>
            <ToolCard
              title={tool.name}
              url={tool.iconUrl}
              onClick={() => onClick(tool)}
              enabled={!isActiveToolExist && tool.fqdn === 'athena'}
            />
          </Column>
        ))}
      </Grid>
      <Dialog
        active={isAthenaDialogActive}
        onClose={() => setIsAthenaDialogActive(false)}
        title="Do you want to configure Smart Agent Chat?"
        subtitle="You can configure it in the Business Manager. If you have already configured it you can go to Smart Agent Chat."
        primaryActionText="Business Manager"
        secondaryActionText="Smart Agent Chat"
        primaryAction={navToBM}
        secondaryAction={openAthenaTab}
      />
    </Container>
  );
};

ToolList.propTypes = {
  toolList: PropTypes.shape([]),
  isActiveToolExist: PropTypes.bool,
  activeToolName: PropTypes.string,
  ectCredentials: PropTypes.shape({}),
  navToBM: PropTypes.func.isRequired,
  navToAthena: PropTypes.func.isRequired,
  navToSetupFqdn: PropTypes.func.isRequired,
  deactivateConfiguration: PropTypes.func.isRequired,
  activateContactSalesTeamDialog: PropTypes.func.isRequired,
};

ToolList.defaultProps = {
  toolList: [],
  isActiveToolExist: false,
  activeToolName: '',
  ectCredentials: {},
};

export default React.memo(ToolList);
